import { Grid, TextField } from "@mui/material";
import { Controller, get, useFormContext } from "react-hook-form";

const FieldLabel = ({ label, required }) => (
  <span>
    {label}
    {required && <span style={{ color: "red", marginLeft: 2 }}>*</span>}
  </span>
);

const CustomerInput = ({ name, label, mt, required, ...props }) => {
  const { control } = useFormContext();
  return (
    <Controller
      control={control}
      name={name}
      render={({ field, formState: { errors } }) => {
        const error = get(errors, name);
        return (
          <Grid
            item
            xs={12}
            mt={mt}
          >
            <TextField
              {...props}
              fullWidth
              label={
                <FieldLabel
                  label={label}
                  required={required}
                />
              }
              value={field.value}
              onChange={field.onChange}
              error={!!error}
              helperText={error?.message}
            />
          </Grid>
        );
      }}
    />
  );
};

export default CustomerInput;
